import { LegacyPortalShippingService } from "@spwn-portal/grpc";
/* eslint-disable no-restricted-imports -- firebase compat: 新たにコードを追加する時は modular API を使う。modular API へ移行したらこのコメントごと削除する */
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
/* eslint-enable no-restricted-imports */
import useSWR from "swr";

import { useConnectClient } from "../../utility/connectWeb";

import type { AddressInfo } from "modules/auth";

const FetchLegacyPortalAddressInfoKey = "fetchLegacyPortalAddressInfo";

export const useLegacyPortalAddressInfo = (isAddressRegistered: boolean) => {
  const auth = firebase.auth();
  const connectClient = useConnectClient(LegacyPortalShippingService);

  const { data } = useSWR(
    auth.currentUser?.emailVerified && isAddressRegistered
      ? FetchLegacyPortalAddressInfoKey
      : null,
    async () => {
      const response = await connectClient.getLegacyPortalAddressInfo({});
      if (!response.legacyPortalAddressInfo) {
        return {
          status: "NOT_FOUND",
        };
      }

      return {
        status: "SUCCESS",
        data: {
          address: response.legacyPortalAddressInfo,
        },
      };
    }
  );

  if (!data || data.status !== "SUCCESS" || !data.data) {
    return {
      addressInfo: null,
      error: new Error("Failed to fetch address info"),
    };
  }

  const { address } = data.data;

  const addressInfo: AddressInfo = {
    userName: address.recipientName ?? "",
    zipCode: address.zipCode ?? "",
    prefecture: address.prefecture ?? "",
    city: address.city ?? "",
    streetNum: address.streetNum ?? "",
    buildingInfo: address.buildingInfo ?? "",
    phone: address.phone ?? "",
  };

  return {
    addressInfo,
    error: null,
  };
};
